import React from 'react';
import { useFormContext } from 'react-hook-form';
import countries from '../../../../common/countries';
import {
    FormTitle, FormSubtitle, FormGroup, FormRow, Label,
    StyledInput, StyledSelect, ErrorText, RequiredBadge,
    INSTITUTION_TYPES
} from '../styles';
import { PhoneInput } from '../../../../common/PhoneInput';

const Step1InstitutionProfile = () => {
    const { register, formState: { errors } } = useFormContext();

    return (
        <div>
            <FormTitle>Institution Profile</FormTitle>
            <FormSubtitle>Provide the legal details of your financial institution.</FormSubtitle>

            <FormGroup>
                <Label htmlFor="institutionName">Full Institution Legal Name<RequiredBadge>*</RequiredBadge></Label>
                <StyledInput
                    type="text"
                    {...register('institutionName')}
                    placeholder="e.g. Global Payments Bank Ltd."
                    $error={!!errors.institutionName}
                />
                {errors.institutionName && <ErrorText>{errors.institutionName.message}</ErrorText>}
            </FormGroup>

            <FormRow>
                <FormGroup>
                    <Label htmlFor="institutionType">Institution Type<RequiredBadge>*</RequiredBadge></Label>
                    <StyledSelect {...register('institutionType')} $error={!!errors.institutionType}>
                        <option value="">Select type</option>
                        {INSTITUTION_TYPES.map(type => <option key={type} value={type}>{type}</option>)}
                    </StyledSelect>
                    {errors.institutionType && <ErrorText>{errors.institutionType.message}</ErrorText>}
                </FormGroup>

                <FormGroup>
                    <Label htmlFor="registrationNumber">Company Registration / License Number<RequiredBadge>*</RequiredBadge></Label>
                    <StyledInput type="text" {...register('registrationNumber')} placeholder="e.g. CRN-123456" $error={!!errors.registrationNumber} />
                    {errors.registrationNumber && <ErrorText>{errors.registrationNumber.message}</ErrorText>}
                </FormGroup>
            </FormRow>

            <FormRow>
                <FormGroup>
                    <Label htmlFor="incorporationCountry">Country of Incorporation<RequiredBadge>*</RequiredBadge></Label>
                    <StyledSelect {...register('incorporationCountry')} $error={!!errors.incorporationCountry}>
                        <option value="">Select country</option>
                        {countries.map(c => <option key={c.code} value={c.name}>{c.flag} {c.name}</option>)}
                    </StyledSelect>
                    {errors.incorporationCountry && <ErrorText>{errors.incorporationCountry.message}</ErrorText>}
                </FormGroup>

                <FormGroup>
                    <Label htmlFor="swiftBic">SWIFT / BIC Code <span style={{ opacity: 0.6, fontWeight: 'normal' }}>— Optional</span></Label>
                    <StyledInput type="text" {...register('swiftBic')} placeholder="e.g. BOFAUS3N" />
                </FormGroup>
            </FormRow>

            <FormGroup>
                <Label htmlFor="headquartersAddress">Headquarters Address<RequiredBadge>*</RequiredBadge></Label>
                <StyledInput type="text" {...register('headquartersAddress')} placeholder="Street Address" $error={!!errors.headquartersAddress} />
                {errors.headquartersAddress && <ErrorText>{errors.headquartersAddress.message}</ErrorText>}
            </FormGroup>

            <FormRow>
                <FormGroup>
                    <Label htmlFor="city">City<RequiredBadge>*</RequiredBadge></Label>
                    <StyledInput type="text" {...register('city')} placeholder="City" $error={!!errors.city} />
                    {errors.city && <ErrorText>{errors.city.message}</ErrorText>}
                </FormGroup>

                <FormGroup>
                    <Label htmlFor="state">State / Province<RequiredBadge>*</RequiredBadge></Label>
                    <StyledInput type="text" {...register('state')} placeholder="State" $error={!!errors.state} />
                    {errors.state && <ErrorText>{errors.state.message}</ErrorText>}
                </FormGroup>

                <FormGroup>
                    <Label htmlFor="zipCode">Postal Code<RequiredBadge>*</RequiredBadge></Label>
                    <StyledInput type="text" {...register('zipCode')} placeholder="Code" $error={!!errors.zipCode} />
                    {errors.zipCode && <ErrorText>{errors.zipCode.message}</ErrorText>}
                </FormGroup>
            </FormRow>

            <FormRow>
                <FormGroup>
                    <Label>Company Phone Number<RequiredBadge>*</RequiredBadge></Label>
                    <PhoneInput
                        dialCodeName="companyPhoneDialCode"
                        numberName="companyPhone"
                        register={register}
                        errors={errors}
                    />
                    {errors.companyPhone && <ErrorText>{errors.companyPhone.message}</ErrorText>}
                </FormGroup>

                <FormGroup>
                    <Label htmlFor="companyEmail">Company Email / Point of Contact<RequiredBadge>*</RequiredBadge></Label>
                    <StyledInput type="email" {...register('companyEmail')} placeholder="contact@institution.com" $error={!!errors.companyEmail} />
                    {errors.companyEmail && <ErrorText>{errors.companyEmail.message}</ErrorText>}
                </FormGroup>
            </FormRow>
        </div>
    );
};

export default Step1InstitutionProfile;
